export default __webpack_public_path__ + "static/media/Innovative.b5beca63.svg";